import { AmplitudeEvent, AmplitudeEventProperties } from '../typings/amplitude';
import { getLandingAttribution } from './landingAttribution';

// Events the SEO loop reports on; each carries the visitor's first and session landing page.
const CONVERSION_EVENTS: AmplitudeEvent[] = [
  'signup_cta_clicked',
  'account_signup_completed',
  'trial_checkout_started',
  'free_trial_started',
  'subscription_converted',
  'tool_unlock_granted',
];

export const identifyUserForAnalytics = (userId: string): void => {
  if (window && 'amplitude' in window) {
    window.amplitude.setUserId(userId);
  }
};

/** Aligns browser `user_id` with `Layout` / server before lifecycle events. */
export const trackAccountSignupCompleted = (userId: string, signupMethod: string): void => {
  identifyUserForAnalytics(userId);
  trackEvent('account_signup_completed', { signup_method: signupMethod });
};

export { syncUserSubscriptionTraits } from './amplitudeUser';

export const trackEvent = <T extends AmplitudeEvent>(
  event: T,
  properties?: T extends keyof AmplitudeEventProperties ? AmplitudeEventProperties[T] : never,
) => {
  if (window.location.hostname === 'localhost') {
    console.log('event', event, properties);
  }

  if (window && 'amplitude' in window) {
    const eventProperties = CONVERSION_EVENTS.includes(event)
      ? { ...getLandingAttribution(), ...properties }
      : properties;

    window.amplitude.track(event, eventProperties);
  }
};
